var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79006 29.0892C4.81806 29.0892 3.9914 28.7677 3.31006 28.1249C2.63006 27.4807 2.29006 26.6992 2.29006 25.7803V5.6904H0.664062V2.38148H9.08206V0.72702H18.9141V2.38148H27.3321V5.6904H25.6641V25.7803C25.6641 26.6992 25.3241 27.4807 24.6441 28.1249C23.9627 28.7677 23.1361 29.0892 22.1641 29.0892H5.79006ZM8.87406 22.4713H12.3741V8.99931H8.87406V22.4713ZM15.5401 22.4713H19.0401V8.99931H15.5401V22.4713Z",
    fill: "#D60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b832ea493c70fb5a40247e0eadccacd1.svg";
export { ForwardRef as ReactComponent };